
import { arrowLeft, arrowRight } from '@/static/arrows';
import { api } from "@/utils/request";

export default { 
  data() {
    return {
      partnerListData: [],
      slickOptions: {
        lazyLoad: 'progressive',
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        infinite: false,
        prevArrow: arrowLeft,
        nextArrow: arrowRight,
        responsive: [
          {
            breakpoint: 540,
            settings: {
              lazyLoad: 'progressive',
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              lazyLoad: 'progressive',
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 992,
            settings: {
              lazyLoad: 'progressive',
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false,
              infinite: false,
              arrows: true,
            }
          },
          {
            breakpoint: 1264,
            settings: {
              lazyLoad: 'progressive',
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: false,
              infinite: false,
              arrows: true
            }
          }
        ]
      },
      fetched: false,
    };
  },
  async created() {
    try {
      const data = await api('partners');
      this.partnerListData = data.result
      this.fetched = true;
    } catch (e) {
      console.error(e);
    }
  },
}
